// Constant definition for mobile width threshold
export const MOBILE_WIDTH = 849;
